export enum StockRouteNames {
  STOCK_ROOT = 'StockRoot',
  STOCK_SITES = 'StockRoot/Sites',
  STOCK_BUSINESS_UNIT = 'StockRoot/BusinessUnit',
}
